/**
 * Created by mly on 2018/4/19.
 */
import Util from '../../../libs/util';
import {mapGetters} from "vuex";
export default {
    data(){
        return {
            expense_types: [],
            expense_type_hash: {},
            search_expense_type_text: ''
        }
    },
    computed: {
        cur_customer(){
            return this.$store.state.cur_customer;
        },
        edit_title(){
            let type = '';
            switch (this.type){
                case 0:
                    type = '费用报销单';
                    break;
                case 1:
                    type = '付款申请单';
                    break;
                case 2:
                    type = '费用预支单';
                    break;
                default:
                    type = '未定义单据类型';
                    break;
            }
            return type;
        },
        search_expense_type_result(){
            let ret = [];
            let search = this.search_expense_type_text;
            this.expense_types.forEach((type)=>{
                if(!type.has_children){
                    if(search){
                        if(type.name.indexOf(search) > -1){
                            ret.push(type);
                        }
                    }else{
                        ret.push(type);
                    }
                }
            });
            return ret;
        },
        ...mapGetters({
            companies: 'async/companies',
            companies_hash: 'async/companies_hash',
            teams: 'async/root_teams',
            teams_hash: 'async/root_teams_hash',
        }),
    },
    created(){
        //
    },
    mounted(){
        //
    },
    methods: {
        getCompanyNameById(id){
            let company = this.companies_hash[id];
            return company ? company.name : '';
        },
        getTeamNameById(id){
            let team = this.teams_hash[id];
            return team ? team.name : '';
        },
        getExpenseTypes(){
            Util.ajax.get(Util.api.get_expense_types).then((response)=>{
                return response.data;
            }).then((res)=>{
                if(res.code === 1){
                    let data = res.data;
                    this.handleExpenseTypes(data);
                }else{
                    this.$Modal.error({
                        title: '错误',
                        content: res.msg
                    });
                }
            }).catch((e)=>{
                console.log(e);
            });
        },
        handleExpenseTypes(expense_types){
            expense_types.forEach((expense_type)=>{
                if(expense_type.parent_id){
                    let parent = this.expense_type_hash[expense_type.parent_id];
                    parent.has_children = true;
                    expense_type.name = parent.name + '-' + expense_type.name;
                }
                this.expense_type_hash[expense_type.id] = expense_type;
                // 弃用后的费用类型不加入数据, 避免在操作时被选中
                if(expense_type.status != -1){
                    this.expense_types.push(expense_type);
                }
                if(expense_type.expense_types.length){
                    this.handleExpenseTypes(expense_type.expense_types);
                }
            });
        },
        getExpenseTypeName(id){
            return id ? this.expense_type_hash[id].name : '';
        },
        setExpenseType(expense, type){
            if(this.check_link_report && !type.fin_expense_type_id){
                this.$Message.error({title: '提示', content: '该费用类别未设置报表对应关系, 不能选择!'});
                return;
            }
            expense.expense_type_id = type.id;
            document.body.click();
        },
    }
}
